<template>
  <div>
     <headernav></headernav>
     <router-view /> 
     <downfooter></downfooter>
  </div>
</template>
<script>

import headernav from './publish/headernav'
import downfooter from './publish/downfooter'
export default {
  components:{
      headernav,downfooter
  },  
  data() {
    return {
      mcdata:[]
    };
  },
  
  created(){
  },
  mounted() {
    
  },
  methods: {
    

  }
};
</script>
<style>
 @import "../assets/css/common.css";
</style>


// WEBPACK FOOTER //
// src/components/main.vue